import { put, call, getContext, takeEvery } from 'redux-saga/effects';
import doCreatePathwaysClient from '@redux/doCreatePathwaysClient';
import {
  fetchSharedPathwaySnapshotsSuccess,
  fetchSharedPathwaySnapshotsFailed,
  utiliseSharedPathwaySnapshotSuccess,
  utiliseSharedPathwaySnapshotFailed,
  IUtiliseSharedPathwaySnapshot,
} from './actions';
import { IRawSharedPathwaySnapshot } from '../pathways/types';
import { mapRawSharedPathwaySnapshot } from '../pathways/utils';
import OrganisationDetailsCache from '@utils/organisationDetailsCache';

export default function* sharedPathwaysRoot() {
  yield takeEvery('sharedPathways/fetchSharedPathwaySnapshots', doFetchSharedPathwaySnapshots);
  yield takeEvery('sharedPathways/utiliseSharedPathwaySnapshot', doUseSharedPathwaySnapshot);
}

export function* doFetchSharedPathwaySnapshots(): any {
  try {
    const pathwaysClient = yield call(doCreatePathwaysClient);
    const orgDetails: OrganisationDetailsCache = yield getContext('organisationDetailsCache');
    let page = 1;
    let next = true;
    let results: any[] = [];
    while (next) {
      const data = yield call(pathwaysClient.listSharedPathwaySnapshots, page);
      if (data.count) {
        results = results.concat(data.results);
      }
      next = data.next;
      page += 1;
    }

    const formattedSharedPathwaySnapshots = results.map((snapshot: IRawSharedPathwaySnapshot) =>
      mapRawSharedPathwaySnapshot(snapshot),
    );

    const organisations = yield Promise.all(
      formattedSharedPathwaySnapshots.map(snapshot => {
        try {
          return orgDetails.get(snapshot.parentOrganisationSlug);
        } catch {
          return undefined;
        }
      }),
    );

    formattedSharedPathwaySnapshots.forEach((snapshot, index) => {
      snapshot.parentName = organisations[index]?.organisation_name;
    });

    yield put(fetchSharedPathwaySnapshotsSuccess(formattedSharedPathwaySnapshots));
  } catch (err) {
    console.error(err);
    yield put(fetchSharedPathwaySnapshotsFailed());
  }
}

export function* doUseSharedPathwaySnapshot({
  payload: { snapshotId, indexEventTypes, existingPathwayId },
}: IUtiliseSharedPathwaySnapshot): any {
  try {
    const pathwaysClient = yield call(doCreatePathwaysClient);
    const createdPathway = yield call(
      pathwaysClient.useSharedPathwaySnapshot,
      snapshotId,
      indexEventTypes,
      existingPathwayId,
    );
    yield put(utiliseSharedPathwaySnapshotSuccess(mapRawSharedPathwaySnapshot(createdPathway)));

    const history = yield getContext('history');
    yield call(history.push, `/procedure/pathway/${createdPathway.id}`);
  } catch (err) {
    console.error(err);
    yield put(utiliseSharedPathwaySnapshotFailed());
  }
}
